/**
 * List component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Ul from '../ul/ul';

export default class List extends PureComponent {

	render() {

		const { items } = this.props;
		
		if (items.length && items[0].item) {

			return (

				<div className="row d-none d-sm-flex mt-9">
					{
						items.map((item, i) => {

							return (

								<div key={'list-grid-' + i} className="col-xs-12 col-lg-4">

									<h4 key={'list-title-' + i} className="h3">{item.title}</h4>
									<Ul items={item.item} classes="list list-cap"></Ul>

								</div>
							)
						})
					}
				</div>
			)
		}
		else {

			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/list/list.js